import { SearchEntity } from './../components/grid/grid.model';
import { Injectable } from '@angular/core';
import { AppConfig } from '../Utilities/app-config.service';
import { ApiService } from './api.service';
import { Contact, LogActivity } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LogActivityService {

  constructor(
    private apiService: ApiService,
    private _appConfig: AppConfig
  ) { }


  saveContact(contact: Contact) {
    return this.apiService.post(this._appConfig.GetUrl('contactMeSave'), contact); // api/agent/enquiry
  }

  logActivity(logActivity: LogActivity) {
    return this.apiService.post(this._appConfig.GetUrl('saveLogActivity'), logActivity); // api/agent/logactivity
  }


  GetVisitProfileOrContactList (searchEntity: SearchEntity) {
    /// Common for visit profile and contact me (SearchEntity is changed)
    return this.apiService.post(this._appConfig.GetUrl('GetLogActivity'), searchEntity);
  }

}
